<template>
    <span v-if="mensagem.status == 0">
        <b-button
            variant="success"
            @click.stop="confirmarEnviar()"
            class="float-right ml-2"
            :disabled="desabilitarEnviar"
        >
            <span> <i class="fa fa-paper-plane-o"></i> Enviar </span>
        </b-button>
    </span>
</template>

<script>
import { conversasHub } from './ConversasHub'

export default {
    props: {
        mensagem: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEnviar() {
            this.$swal({
                title: 'Enviar Mensagem',
                html: `Confirma o envio da mensagem?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.enviarConversa()
                }
            })
        },

        async enviarConversa() {
            this.$store.dispatch('addRequest')
            try {
                const textoPuro = this.mensagem.conteudo
                    .replace(/<[^>]+>/g, '')
                    .trim()
                // Monta o array de IDs dos destinatários
                const participantes = Array.isArray(this.mensagem.destinatarios)
                    ? this.mensagem.destinatarios.map((d) => d.fornecedorId)
                    : []

                const fornecedorId =
                    this.$store.getters.fornecedor.fornecedorId || null

                await conversasHub.connection.invoke(
                    'EnviarConversa',
                    this.mensagem.assunto,
                    this.$store.getters.usuario.nome,
                    this.$store.getters.usuario.usuarioId,
                    textoPuro,
                    participantes,
                    fornecedorId
                )

                this.$toast.success(
                    'Conversa iniciada com sucesso!',
                    'OK',
                    this.$toastConfig.success
                )
                this.$router.push({ name: 'Mensagens' })
            } catch (error) {
                console.error('Erro ao iniciar conversa:', error)
                this.$toast.error(
                    'Erro ao iniciar conversa',
                    'ERROR',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        }
    },

    computed: {
        desabilitarEnviar() {
            return !(
                this.mensagem.assunto &&
                this.mensagem.assunto.length > 0 &&
                this.mensagem.conteudo &&
                this.mensagem.conteudo.length > 0
            )
        }
    }
}
</script>
